module.exports = __webpack_public_path__ + "media/images/common/icon-logo-white-39dc1e181d276b633ea51ec90dc0075a.png";